<template>
  <el-form
    label-position="top"
    :model="formSignup"
    class="text-left pd-x-1 set-form-regis"
    :rules="rules"
    ref="formSignup"
  >
    <el-row :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="องค์กร" prop="agency">
          <el-input v-model="formSignup.agency"></el-input>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        :sm="formSignup.agencyType == 8 ? 4 : 12"
        class="pd-r-less"
      >
        <el-form-item label="ประเภทองค์กร" prop="agencyType">
          <el-select
            v-model="formSignup.agencyType"
            placeholder="ประเภทองค์กร"
            class="width-100"
          >
            <el-option
              v-for="item in agencyTypeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col v-if="formSignup.agencyType == 8" :span="12" :sm="8">
        <el-form-item label="โปรดระบุ" prop="etc">
          <el-input v-model="formSignup.etc"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24" :sm="12">
        <el-form-item label="ที่อยู่" prop="address">
          <el-input v-model="formSignup.address"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="รหัสไปรษณีย์" prop="postcode">
          <ThailandAutoComplete
            v-model="formSignup.postcode"
            type="zipcode"
            @select="selectAddress"
            @input="checkValid('postcode')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="ตำบล/แขวง" prop="subDistrict">
          <ThailandAutoComplete
            v-model="formSignup.subDistrict"
            type="district"
            @select="selectAddress"
            @input="checkValid('subDistrict')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="อำเภอ/เขต" prop="district">
          <ThailandAutoComplete
            v-model="formSignup.district"
            type="amphoe"
            @select="selectAddress"
            @input="checkValid('district')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="pd-b-5">
        <el-form-item label="จังหวัด" prop="province">
          <ThailandAutoComplete
            v-model="formSignup.province"
            type="province"
            @select="selectAddress"
            @input="checkValid('province')"
            color="#409EFF"
            class="form-input"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" class="pd-y-3">
        <el-button
          @click="nextStep('formSignup')"
          type="primary"
          class="width-100 button-auth"
          round
          >{{ from == "signup" ? "ขั้นตอนต่อไป" : "บันทึก" }}</el-button
        >
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import ThailandAutoComplete from "vue-thailand-address-autocomplete";

export default {
  components: {
    ThailandAutoComplete,
  },
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
    from: {
      type: String,
      default() {
        return "signup";
      },
    },
  },
  computed: {
    agencyTypeList() {
      return this.$store.state.agencyTypeList;
    },
  },
  data() {
    return {
      formSignup: {
        agency: "",
        agencyType: "",
        etc: "",
        address: "",
        postcode: "",
        subDistrict: "",
        district: "",
        province: "",
      },
      rules: {
        agency: [
          { required: true, message: "กรุณากรอกชื่อองค์กร", trigger: "blur" },
        ],
        agencyType: [
          {
            required: true,
            message: "กรุณาเลือกประเภทองค์กร",
            trigger: ["blur", "change"],
          },
        ],
        etc: [
          {
            required: true,
            message: "กรุณากรอกประเภทองค์กร",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "กรุณากรอกที่อยู่",
            trigger: "blur",
          },
        ],
        postcode: [
          {
            required: true,
            message: "กรุณากรอกรหัสไปรษณีย์",
            trigger: ["blur", "change"],
          },
          {
            min: 5,
            max: 5,
            message: "กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง",
            trigger: ["blur", "change"],
          },
        ],
        subDistrict: [
          {
            required: true,
            message: "กรุณากรอกตำบล",
            trigger: ["blur", "change"],
          },
        ],
        district: [
          {
            required: true,
            message: "กรุณากรอกอำเภอ",
            trigger: ["blur", "change"],
          },
        ],
        province: [
          {
            required: true,
            message: "กรุณากรอกจังหวัด",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    value() {
      this.setValue();
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.value) {
        this.formSignup = {
          agency: this.value.agency,
          agencyType: this.value.agencyType ? this.value.agencyType : "",
          etc: this.value.etc,
          address: this.value.address,
          postcode: this.value.postcode,
          subDistrict: this.value.subDistrict,
          district: this.value.district,
          province: this.value.province,
        };
      }
    },
    selectAddress(address) {
      this.formSignup.postcode = address.zipcode;
      this.formSignup.subDistrict = address.district;
      this.formSignup.district = address.amphoe;
      this.formSignup.province = address.province;
      this.$refs["formSignup"].validateField("postcode");
      this.$refs["formSignup"].validateField("subDistrict");
      this.$refs["formSignup"].validateField("district");
      this.$refs["formSignup"].validateField("province");
    },
    nextStep(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("setFormStep", this.formSignup);
        }
      });
    },
    checkValid(field) {
      this.$refs["formSignup"].validateField(field);
    },
  },
};
</script>
